
<template>
  <div
    aria-label="checkbox-group"
    class="s-checkbox-group"
    :class="{'is-row': row}"
    data-qa="checkbox-group"
    role="group">
    <slot/>
  </div>
</template>
<script>
import emitter from '../../mixins/emitter'

/**
 * Группа Checkbox
 * @displayName CheckboxGroup
 */
export default {
  name: 'sCheckboxGroup',
  componentName: 'sCheckboxGroup',
  mixins: [emitter],
  inject: {
    sFormItem: {
      default: ''
    }
  },
  props: {
    /**
     * Значение
     */
    value: {
      type: [Array],
    },
    /**
     * отключение
     */
    disabled: {
      type: Boolean,
    },
    /**
     * Только чтение
     */
    readonly: {
      type: Boolean,
    },
    /**
     * минимальное количество отмеченных эллементов
     */
    min: {
      type: Number,
    },
    /**
     * максимальное количество отмеченных эллементов
     */
    max: {
      type: Number,
    },
    /**
     * цвет границы и фона, когда кнопка активна
     */
    fill: {
      type: String,
    },
    /**
     * цвет шрифта, когда кнопка активна
     */
    textColor: {
      type: String,
    },
    /**
    * отобразить строкой
    */
    row: {
      type: Boolean,
    },
  },
  watch: {
    value(value) {
      this.dispatch('sFormItem', 's.form.change', [value])
    }
  }
}
</script>